import React from 'react'
import { _ } from 'utils'
import { categoriesQuery, tagsQuery } from '../graphql/query'
import {
    createAttendeeCategory,
    createAttendeeTag,
    deleteAttendeeCategory,
    deleteAttendeeTag,
    updateAttendeeCategoryOrder, updateAttendeeCategory,
    updateAttendeeTag,
    updateAttendeeTagOrder
} from '../graphql/mutation'
import TagsPage from '../../tags/TagsPage'

const ProgramTags = () => (
    <TagsPage
        description={_('attendee.manage_tags.description')}
        tagKey="userTags"
        categoryKey="attendeeTagCategories"
        tagsQuery={tagsQuery}
        categoriesQuery={categoriesQuery}
        updateTagOrder={updateAttendeeTagOrder}
        updateCategoryOrder={updateAttendeeCategoryOrder}
        deleteCategory={deleteAttendeeCategory}
        deleteTag={deleteAttendeeTag}
        updateTag={updateAttendeeTag}
        createTag={createAttendeeTag}
        createCategory={createAttendeeCategory}
        updateCategory={updateAttendeeCategory}
    />
)

export default ProgramTags
